import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { TranscriptDisplay } from '@/entities/call'
import { useConversationMessages } from '@/hooks/useSimulations'
import { messagesToTranscript } from '@/shared/lib/messagesToTranscript'

interface ConversationViewerProps {
  testId: number
  conversationId: string
  onClose: () => void
}

export function ConversationViewer({ testId, conversationId, onClose }: ConversationViewerProps) {
  const { data: messages = [], isLoading } = useConversationMessages(testId, conversationId)

  const transcriptEvents = messagesToTranscript(messages)

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent className="max-w-lg max-h-[85vh] flex flex-col p-0 gap-0">
        <DialogHeader className="p-4 pb-2 flex-shrink-0">
          <DialogTitle className="text-sm">Conversation</DialogTitle>
        </DialogHeader>

        <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-4">
          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin h-5 w-5 border-2 border-primary border-t-transparent rounded-full" />
            </div>
          ) : transcriptEvents.length === 0 ? (
            <p className="text-xs text-gray-400 text-center py-4">No messages</p>
          ) : (
            <div className="bg-white rounded border border-gray-100 p-1">
              <TranscriptDisplay transcript={JSON.stringify(transcriptEvents)} />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
